import { defineStyleConfig } from '@chakra-ui/styled-system';
import tokensToTheme from '../../tokens/tokensToTheme.json';

const SelectableTagTheme = defineStyleConfig({
  baseStyle: {
    px: '8',
    py: '4',
    cursor: 'pointer',
    display: 'inline',
    border: '1px solid',
    whiteSpace: 'nowrap',
    borderColor: 'border.strong',
    borderRadius: '4',
    backgroundColor: 'background.primary',
    _hover: {
      backgroundColor: 'background.hover',
      _peerChecked: {
        backgroundColor: 'background.selected-hover',
      },
    },
    _peerChecked: {
      borderColor: 'border.selected',
      backgroundColor: 'background.selected',
    },
    _peerFocusVisible: {
      backgroundColor: 'background.hover',
      _checked: {
        backgroundColor: 'background.selected-hover',
      },
    },
    ...tokensToTheme.textStyles['comp/tag/sm'],
  },
});

export default SelectableTagTheme;
